import { render } from "./TalentIcon.vue?vue&type=template&id=a7099d82"
import script from "./TalentIcon.vue?vue&type=script&lang=js"
export * from "./TalentIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__